export const orderData = {
  "orderId": "MX9811250605QAS309852147",
  "orderDate": "2025-06-05T22:28:08.854Z",
  "deliveryDate": "2025-06-05T22:28:08.956Z",
  "acknowledgementStatus": null,
  "acknowledgementProcessingStatus": null,
  "acknowledgementSubStatus": null,
  "sourceInvoiceId": "MX9811250605QAS309852147",
  "alternateOrderId": "MX9811250605QAS309852147",
  "marketPlaceOrderId": "MX9811250605QAS309852147",
  "soldCustomerId": "0100520734",
  "orderType": "ZV0R",
  "paymentTermsCode": null,
  "orderPaymentStatus": null,
  "reasonDescription": null,
  "invoiceDownload": null,
  "routeId": "MX9811",
  "routeTypeId": "30",
  "routeSalesRepWorkForceId": null,
  "totalGrossAmount": 871.94,
  "totalTaxAmount": 69.78,
  "totalDiscountAmount": 0,
  "totalPromotionAmount": 0,
  "totalNetPrice": 941.72,
  "orderLocationId": null,
  "alternativeLocationId": "80CT",
  "customerGTMU": null,
  "visitScheduleId": null,
  "customerPoId": null,
  "countryIsoCode": null,
  "processedStatus": "completed",
  "rewardsProcessedDate": "2025-06-05T22:27:15.770119Z",
  "dollarSpendProcessedDate": "2025-06-05T22:27:15.770119Z",
  "dollarSpend": 94,
  "dollarSpendCalculated": 94,
  "processingNotes": null,
  "items": [
      {
          "type": 1,
          "item": 1,
          "productId": "000000000300051358",
          "requestedQuantity": 5,
          "confirmedQuantity": 5,
          "changed": 0,
          "unitPrice": 13.87,
          "materialUom": "EA",
          "sourceOnlineLineId": "9",
          "saleUom": "EA",
          "baseUom": null,
          "alternativeOrderLineNumber": "9",
          "itemCategoryId": null,
          "itemCategoryType": null,
          "conversionMultiplierToBase": null,
          "deliveryMethod": null,
          "digitalAddress": null,
          "deposit": null,
          "depositWithLineItem": null,
          "removedStatus": null,
          "additionalItemStatus": null,
          "replacementProduct": null,
          "orderState": null,
          "orderPrice": 74.9,
          "discounts": [],
          "fulfillment": {
              "fulfilledQuantity": "5",
              "trackingId": null,
              "shippingDate": null,
              "rejectedQuantity": null
          },
          "adjustments": {
              "adjustmentType": null,
              "reasonCode": null,
              "quantity": null
          },
          "taxesInformation": {
              "name": null,
              "type": null,
              "value": null
          },
          "discount": 0,
          "discountIncludingTax": -5.55,
          "taxAmount": 5.55,
          "grandTotal": 74.9,
          "taxDepositAmount": null,
          "securityDeposit": null,
          "sugarLevyTax": null,
          "conversion": null,
          "promotionPoint": null,
          "priceListId": null,
          "idAgreement": null,
          "totalGrossAmount": 69.35,
          "totalDiscountAmount": 0,
          "totalTaxAmount": 5.55,
          "totalNetAmount": 74.9,
          "totalPromotionAmount": 0,
          "promotional": false,
          "promotionId": null,
          "promotionName": null,
          "rewardItemId": null,
          "totalPoints": null,
          "rewardsType": null,
          "rewardStatus": null,
          "expirationDate": null,
          "rewardPrice": null,
          "routeTypeId": null,
          "refunded": null,
          "code": null,
          "codeAdded": null,
          "referenceNo": null,
          "url": null,
          "id": null,
          "expired": null,
          "digitalProductExpirationDate": null,
          "created": null,
          "rewardOrderNumber": null,
          "sentToSourceSystem": null
      },
      {
          "type": 3,
          "item": 3,
          "productId": "000000000300059144",
          "requestedQuantity": 4,
          "confirmedQuantity": 4,
          "changed": 0,
          "unitPrice": 14.12,
          "materialUom": "EA",
          "sourceOnlineLineId": "5",
          "saleUom": "EA",
          "baseUom": null,
          "alternativeOrderLineNumber": "5",
          "itemCategoryId": null,
          "itemCategoryType": null,
          "conversionMultiplierToBase": null,
          "deliveryMethod": null,
          "digitalAddress": null,
          "deposit": null,
          "depositWithLineItem": null,
          "removedStatus": null,
          "additionalItemStatus": null,
          "replacementProduct": null,
          "orderState": null,
          "orderPrice": 61,
          "discounts": [],
          "fulfillment": {
              "fulfilledQuantity": "4",
              "trackingId": null,
              "shippingDate": null,
              "rejectedQuantity": null
          },
          "adjustments": {
              "adjustmentType": null,
              "reasonCode": null,
              "quantity": null
          },
          "taxesInformation": {
              "name": null,
              "type": null,
              "value": null
          },
          "discount": 0,
          "discountIncludingTax": -4.52,
          "taxAmount": 4.52,
          "grandTotal": 61,
          "taxDepositAmount": null,
          "securityDeposit": null,
          "sugarLevyTax": null,
          "conversion": null,
          "promotionPoint": null,
          "priceListId": null,
          "idAgreement": null,
          "totalGrossAmount": 56.48,
          "totalDiscountAmount": 0,
          "totalTaxAmount": 4.52,
          "totalNetAmount": 61,
          "totalPromotionAmount": 0,
          "promotional": false,
          "promotionId": null,
          "promotionName": null,
          "rewardItemId": null,
          "totalPoints": null,
          "rewardsType": null,
          "rewardStatus": null,
          "expirationDate": null,
          "rewardPrice": null,
          "routeTypeId": null,
          "refunded": null,
          "code": null,
          "codeAdded": null,
          "referenceNo": null,
          "url": null,
          "id": null,
          "expired": null,
          "digitalProductExpirationDate": null,
          "created": null,
          "rewardOrderNumber": null,
          "sentToSourceSystem": null
      },
      {
          "type": 2,
          "item": 2,
          "productId": "000000000300056315",
          "requestedQuantity": 5,
          "confirmedQuantity": 5,
          "changed": 0,
          "unitPrice": 14.12,
          "materialUom": "EA",
          "sourceOnlineLineId": "2",
          "saleUom": "EA",
          "baseUom": null,
          "alternativeOrderLineNumber": "2",
          "itemCategoryId": null,
          "itemCategoryType": null,
          "conversionMultiplierToBase": null,
          "deliveryMethod": null,
          "digitalAddress": null,
          "deposit": null,
          "depositWithLineItem": null,
          "removedStatus": null,
          "additionalItemStatus": null,
          "replacementProduct": null,
          "orderState": null,
          "orderPrice": 76.25,
          "discounts": [],
          "fulfillment": {
              "fulfilledQuantity": "5",
              "trackingId": null,
              "shippingDate": null,
              "rejectedQuantity": null
          },
          "adjustments": {
              "adjustmentType": null,
              "reasonCode": null,
              "quantity": null
          },
          "taxesInformation": {
              "name": null,
              "type": null,
              "value": null
          },
          "discount": 0,
          "discountIncludingTax": -5.65,
          "taxAmount": 5.65,
          "grandTotal": 76.25,
          "taxDepositAmount": null,
          "securityDeposit": null,
          "sugarLevyTax": null,
          "conversion": null,
          "promotionPoint": null,
          "priceListId": null,
          "idAgreement": null,
          "totalGrossAmount": 70.6,
          "totalDiscountAmount": 0,
          "totalTaxAmount": 5.65,
          "totalNetAmount": 76.25,
          "totalPromotionAmount": 0,
          "promotional": false,
          "promotionId": null,
          "promotionName": null,
          "rewardItemId": null,
          "totalPoints": null,
          "rewardsType": null,
          "rewardStatus": null,
          "expirationDate": null,
          "rewardPrice": null,
          "routeTypeId": null,
          "refunded": null,
          "code": null,
          "codeAdded": null,
          "referenceNo": null,
          "url": null,
          "id": null,
          "expired": null,
          "digitalProductExpirationDate": null,
          "created": null,
          "rewardOrderNumber": null,
          "sentToSourceSystem": null
      },
      {
          "type": 5,
          "item": 5,
          "productId": "000000000300060344",
          "requestedQuantity": 4,
          "confirmedQuantity": 4,
          "changed": 0,
          "unitPrice": 14.12,
          "materialUom": "EA",
          "sourceOnlineLineId": "12",
          "saleUom": "EA",
          "baseUom": null,
          "alternativeOrderLineNumber": "12",
          "itemCategoryId": null,
          "itemCategoryType": null,
          "conversionMultiplierToBase": null,
          "deliveryMethod": null,
          "digitalAddress": null,
          "deposit": null,
          "depositWithLineItem": null,
          "removedStatus": null,
          "additionalItemStatus": null,
          "replacementProduct": null,
          "orderState": null,
          "orderPrice": 61,
          "discounts": [],
          "fulfillment": {
              "fulfilledQuantity": "4",
              "trackingId": null,
              "shippingDate": null,
              "rejectedQuantity": null
          },
          "adjustments": {
              "adjustmentType": null,
              "reasonCode": null,
              "quantity": null
          },
          "taxesInformation": {
              "name": null,
              "type": null,
              "value": null
          },
          "discount": 0,
          "discountIncludingTax": -4.52,
          "taxAmount": 4.52,
          "grandTotal": 61,
          "taxDepositAmount": null,
          "securityDeposit": null,
          "sugarLevyTax": null,
          "conversion": null,
          "promotionPoint": null,
          "priceListId": null,
          "idAgreement": null,
          "totalGrossAmount": 56.48,
          "totalDiscountAmount": 0,
          "totalTaxAmount": 4.52,
          "totalNetAmount": 61,
          "totalPromotionAmount": 0,
          "promotional": false,
          "promotionId": null,
          "promotionName": null,
          "rewardItemId": null,
          "totalPoints": null,
          "rewardsType": null,
          "rewardStatus": null,
          "expirationDate": null,
          "rewardPrice": null,
          "routeTypeId": null,
          "refunded": null,
          "code": null,
          "codeAdded": null,
          "referenceNo": null,
          "url": null,
          "id": null,
          "expired": null,
          "digitalProductExpirationDate": null,
          "created": null,
          "rewardOrderNumber": null,
          "sentToSourceSystem": null
      },
      {
          "type": null,
          "item": null,
          "productId": "000000000300055266",
          "requestedQuantity": 8,
          "confirmedQuantity": 8,
          "changed": 0,
          "unitPrice": 14.12,
          "materialUom": "EA",
          "sourceOnlineLineId": "1",
          "saleUom": "EA",
          "baseUom": null,
          "alternativeOrderLineNumber": "1",
          "itemCategoryId": null,
          "itemCategoryType": null,
          "conversionMultiplierToBase": null,
          "deliveryMethod": null,
          "digitalAddress": null,
          "deposit": null,
          "depositWithLineItem": null,
          "removedStatus": null,
          "additionalItemStatus": null,
          "replacementProduct": null,
          "orderState": null,
          "orderPrice": 122,
          "discounts": [],
          "fulfillment": {
              "fulfilledQuantity": "8",
              "trackingId": null,
              "shippingDate": null,
              "rejectedQuantity": null
          },
          "adjustments": {
              "adjustmentType": null,
              "reasonCode": null,
              "quantity": null
          },
          "taxesInformation": {
              "name": null,
              "type": null,
              "value": null
          },
          "discount": 0,
          "discountIncludingTax": -9.04,
          "taxAmount": 9.04,
          "grandTotal": 122,
          "taxDepositAmount": null,
          "securityDeposit": null,
          "sugarLevyTax": null,
          "conversion": null,
          "promotionPoint": null,
          "priceListId": null,
          "idAgreement": null,
          "totalGrossAmount": 112.96,
          "totalDiscountAmount": 0,
          "totalTaxAmount": 9.04,
          "totalNetAmount": 122,
          "totalPromotionAmount": 0,
          "promotional": false,
          "promotionId": null,
          "promotionName": null,
          "rewardItemId": null,
          "totalPoints": null,
          "rewardsType": null,
          "rewardStatus": null,
          "expirationDate": null,
          "rewardPrice": null,
          "routeTypeId": null,
          "refunded": null,
          "code": null,
          "codeAdded": null,
          "referenceNo": null,
          "url": null,
          "id": null,
          "expired": null,
          "digitalProductExpirationDate": null,
          "created": null,
          "rewardOrderNumber": null,
          "sentToSourceSystem": null
      },
      {
          "type": null,
          "item": null,
          "productId": "000000000300062244",
          "requestedQuantity": 6,
          "confirmedQuantity": 6,
          "changed": 0,
          "unitPrice": 14.12,
          "materialUom": "EA",
          "sourceOnlineLineId": "7",
          "saleUom": "EA",
          "baseUom": null,
          "alternativeOrderLineNumber": "7",
          "itemCategoryId": null,
          "itemCategoryType": null,
          "conversionMultiplierToBase": null,
          "deliveryMethod": null,
          "digitalAddress": null,
          "deposit": null,
          "depositWithLineItem": null,
          "removedStatus": null,
          "additionalItemStatus": null,
          "replacementProduct": null,
          "orderState": null,
          "orderPrice": 91.5,
          "discounts": [],
          "fulfillment": {
              "fulfilledQuantity": "6",
              "trackingId": null,
              "shippingDate": null,
              "rejectedQuantity": null
          },
          "adjustments": {
              "adjustmentType": null,
              "reasonCode": null,
              "quantity": null
          },
          "taxesInformation": {
              "name": null,
              "type": null,
              "value": null
          },
          "discount": 0,
          "discountIncludingTax": -6.78,
          "taxAmount": 6.78,
          "grandTotal": 91.5,
          "taxDepositAmount": null,
          "securityDeposit": null,
          "sugarLevyTax": null,
          "conversion": null,
          "promotionPoint": null,
          "priceListId": null,
          "idAgreement": null,
          "totalGrossAmount": 84.72,
          "totalDiscountAmount": 0,
          "totalTaxAmount": 6.78,
          "totalNetAmount": 91.5,
          "totalPromotionAmount": 0,
          "promotional": false,
          "promotionId": null,
          "promotionName": null,
          "rewardItemId": null,
          "totalPoints": null,
          "rewardsType": null,
          "rewardStatus": null,
          "expirationDate": null,
          "rewardPrice": null,
          "routeTypeId": null,
          "refunded": null,
          "code": null,
          "codeAdded": null,
          "referenceNo": null,
          "url": null,
          "id": null,
          "expired": null,
          "digitalProductExpirationDate": null,
          "created": null,
          "rewardOrderNumber": null,
          "sentToSourceSystem": null
      },
      {
          "type": null,
          "item": null,
          "productId": "000000000300062390",
          "requestedQuantity": 4,
          "confirmedQuantity": 4,
          "changed": 0,
          "unitPrice": 13.87,
          "materialUom": "EA",
          "sourceOnlineLineId": "10",
          "saleUom": "EA",
          "baseUom": null,
          "alternativeOrderLineNumber": "10",
          "itemCategoryId": null,
          "itemCategoryType": null,
          "conversionMultiplierToBase": null,
          "deliveryMethod": null,
          "digitalAddress": null,
          "deposit": null,
          "depositWithLineItem": null,
          "removedStatus": null,
          "additionalItemStatus": null,
          "replacementProduct": null,
          "orderState": null,
          "orderPrice": 59.92,
          "discounts": [],
          "fulfillment": {
              "fulfilledQuantity": "4",
              "trackingId": null,
              "shippingDate": null,
              "rejectedQuantity": null
          },
          "adjustments": {
              "adjustmentType": null,
              "reasonCode": null,
              "quantity": null
          },
          "taxesInformation": {
              "name": null,
              "type": null,
              "value": null
          },
          "discount": 0,
          "discountIncludingTax": -4.44,
          "taxAmount": 4.44,
          "grandTotal": 59.92,
          "taxDepositAmount": null,
          "securityDeposit": null,
          "sugarLevyTax": null,
          "conversion": null,
          "promotionPoint": null,
          "priceListId": null,
          "idAgreement": null,
          "totalGrossAmount": 55.48,
          "totalDiscountAmount": 0,
          "totalTaxAmount": 4.44,
          "totalNetAmount": 59.92,
          "totalPromotionAmount": 0,
          "promotional": false,
          "promotionId": null,
          "promotionName": null,
          "rewardItemId": null,
          "totalPoints": null,
          "rewardsType": null,
          "rewardStatus": null,
          "expirationDate": null,
          "rewardPrice": null,
          "routeTypeId": null,
          "refunded": null,
          "code": null,
          "codeAdded": null,
          "referenceNo": null,
          "url": null,
          "id": null,
          "expired": null,
          "digitalProductExpirationDate": null,
          "created": null,
          "rewardOrderNumber": null,
          "sentToSourceSystem": null
      },
      {
          "type": null,
          "item": null,
          "productId": "000000000300062245",
          "requestedQuantity": 6,
          "confirmedQuantity": 6,
          "changed": 0,
          "unitPrice": 14.12,
          "materialUom": "EA",
          "sourceOnlineLineId": "8",
          "saleUom": "EA",
          "baseUom": null,
          "alternativeOrderLineNumber": "8",
          "itemCategoryId": null,
          "itemCategoryType": null,
          "conversionMultiplierToBase": null,
          "deliveryMethod": null,
          "digitalAddress": null,
          "deposit": null,
          "depositWithLineItem": null,
          "removedStatus": null,
          "additionalItemStatus": null,
          "replacementProduct": null,
          "orderState": null,
          "orderPrice": 91.5,
          "discounts": [],
          "fulfillment": {
              "fulfilledQuantity": "6",
              "trackingId": null,
              "shippingDate": null,
              "rejectedQuantity": null
          },
          "adjustments": {
              "adjustmentType": null,
              "reasonCode": null,
              "quantity": null
          },
          "taxesInformation": {
              "name": null,
              "type": null,
              "value": null
          },
          "discount": 0,
          "discountIncludingTax": -6.78,
          "taxAmount": 6.78,
          "grandTotal": 91.5,
          "taxDepositAmount": null,
          "securityDeposit": null,
          "sugarLevyTax": null,
          "conversion": null,
          "promotionPoint": null,
          "priceListId": null,
          "idAgreement": null,
          "totalGrossAmount": 84.72,
          "totalDiscountAmount": 0,
          "totalTaxAmount": 6.78,
          "totalNetAmount": 91.5,
          "totalPromotionAmount": 0,
          "promotional": false,
          "promotionId": null,
          "promotionName": null,
          "rewardItemId": null,
          "totalPoints": null,
          "rewardsType": null,
          "rewardStatus": null,
          "expirationDate": null,
          "rewardPrice": null,
          "routeTypeId": null,
          "refunded": null,
          "code": null,
          "codeAdded": null,
          "referenceNo": null,
          "url": null,
          "id": null,
          "expired": null,
          "digitalProductExpirationDate": null,
          "created": null,
          "rewardOrderNumber": null,
          "sentToSourceSystem": null
      },
      {
          "type": null,
          "item": null,
          "productId": "000000000300062346",
          "requestedQuantity": 4,
          "confirmedQuantity": 4,
          "changed": 0,
          "unitPrice": 14.12,
          "materialUom": "EA",
          "sourceOnlineLineId": "3",
          "saleUom": "EA",
          "baseUom": null,
          "alternativeOrderLineNumber": "3",
          "itemCategoryId": null,
          "itemCategoryType": null,
          "conversionMultiplierToBase": null,
          "deliveryMethod": null,
          "digitalAddress": null,
          "deposit": null,
          "depositWithLineItem": null,
          "removedStatus": null,
          "additionalItemStatus": null,
          "replacementProduct": null,
          "orderState": null,
          "orderPrice": 61,
          "discounts": [],
          "fulfillment": {
              "fulfilledQuantity": "4",
              "trackingId": null,
              "shippingDate": null,
              "rejectedQuantity": null
          },
          "adjustments": {
              "adjustmentType": null,
              "reasonCode": null,
              "quantity": null
          },
          "taxesInformation": {
              "name": null,
              "type": null,
              "value": null
          },
          "discount": 0,
          "discountIncludingTax": -4.52,
          "taxAmount": 4.52,
          "grandTotal": 61,
          "taxDepositAmount": null,
          "securityDeposit": null,
          "sugarLevyTax": null,
          "conversion": null,
          "promotionPoint": null,
          "priceListId": null,
          "idAgreement": null,
          "totalGrossAmount": 56.48,
          "totalDiscountAmount": 0,
          "totalTaxAmount": 4.52,
          "totalNetAmount": 61,
          "totalPromotionAmount": 0,
          "promotional": false,
          "promotionId": null,
          "promotionName": null,
          "rewardItemId": null,
          "totalPoints": null,
          "rewardsType": null,
          "rewardStatus": null,
          "expirationDate": null,
          "rewardPrice": null,
          "routeTypeId": null,
          "refunded": null,
          "code": null,
          "codeAdded": null,
          "referenceNo": null,
          "url": null,
          "id": null,
          "expired": null,
          "digitalProductExpirationDate": null,
          "created": null,
          "rewardOrderNumber": null,
          "sentToSourceSystem": null
      },
      {
          "type": null,
          "item": null,
          "productId": "000000000300061818",
          "requestedQuantity": 5,
          "confirmedQuantity": 5,
          "changed": 0,
          "unitPrice": 14.12,
          "materialUom": "EA",
          "sourceOnlineLineId": "4",
          "saleUom": "EA",
          "baseUom": null,
          "alternativeOrderLineNumber": "4",
          "itemCategoryId": null,
          "itemCategoryType": null,
          "conversionMultiplierToBase": null,
          "deliveryMethod": null,
          "digitalAddress": null,
          "deposit": null,
          "depositWithLineItem": null,
          "removedStatus": null,
          "additionalItemStatus": null,
          "replacementProduct": null,
          "orderState": null,
          "orderPrice": 76.25,
          "discounts": [],
          "fulfillment": {
              "fulfilledQuantity": "5",
              "trackingId": null,
              "shippingDate": null,
              "rejectedQuantity": null
          },
          "adjustments": {
              "adjustmentType": null,
              "reasonCode": null,
              "quantity": null
          },
          "taxesInformation": {
              "name": null,
              "type": null,
              "value": null
          },
          "discount": 0,
          "discountIncludingTax": -5.65,
          "taxAmount": 5.65,
          "grandTotal": 76.25,
          "taxDepositAmount": null,
          "securityDeposit": null,
          "sugarLevyTax": null,
          "conversion": null,
          "promotionPoint": null,
          "priceListId": null,
          "idAgreement": null,
          "totalGrossAmount": 70.6,
          "totalDiscountAmount": 0,
          "totalTaxAmount": 5.65,
          "totalNetAmount": 76.25,
          "totalPromotionAmount": 0,
          "promotional": false,
          "promotionId": null,
          "promotionName": null,
          "rewardItemId": null,
          "totalPoints": null,
          "rewardsType": null,
          "rewardStatus": null,
          "expirationDate": null,
          "rewardPrice": null,
          "routeTypeId": null,
          "refunded": null,
          "code": null,
          "codeAdded": null,
          "referenceNo": null,
          "url": null,
          "id": null,
          "expired": null,
          "digitalProductExpirationDate": null,
          "created": null,
          "rewardOrderNumber": null,
          "sentToSourceSystem": null
      },
      {
          "type": null,
          "item": null,
          "productId": "000000000300061032",
          "requestedQuantity": 5,
          "confirmedQuantity": 5,
          "changed": 0,
          "unitPrice": 13.87,
          "materialUom": "EA",
          "sourceOnlineLineId": "11",
          "saleUom": "EA",
          "baseUom": null,
          "alternativeOrderLineNumber": "11",
          "itemCategoryId": null,
          "itemCategoryType": null,
          "conversionMultiplierToBase": null,
          "deliveryMethod": null,
          "digitalAddress": null,
          "deposit": null,
          "depositWithLineItem": null,
          "removedStatus": null,
          "additionalItemStatus": null,
          "replacementProduct": null,
          "orderState": null,
          "orderPrice": 74.9,
          "discounts": [],
          "fulfillment": {
              "fulfilledQuantity": "5",
              "trackingId": null,
              "shippingDate": null,
              "rejectedQuantity": null
          },
          "adjustments": {
              "adjustmentType": null,
              "reasonCode": null,
              "quantity": null
          },
          "taxesInformation": {
              "name": null,
              "type": null,
              "value": null
          },
          "discount": 0,
          "discountIncludingTax": -5.55,
          "taxAmount": 5.55,
          "grandTotal": 74.9,
          "taxDepositAmount": null,
          "securityDeposit": null,
          "sugarLevyTax": null,
          "conversion": null,
          "promotionPoint": null,
          "priceListId": null,
          "idAgreement": null,
          "totalGrossAmount": 69.35,
          "totalDiscountAmount": 0,
          "totalTaxAmount": 5.55,
          "totalNetAmount": 74.9,
          "totalPromotionAmount": 0,
          "promotional": false,
          "promotionId": null,
          "promotionName": null,
          "rewardItemId": null,
          "totalPoints": null,
          "rewardsType": null,
          "rewardStatus": null,
          "expirationDate": null,
          "rewardPrice": null,
          "routeTypeId": null,
          "refunded": null,
          "code": null,
          "codeAdded": null,
          "referenceNo": null,
          "url": null,
          "id": null,
          "expired": null,
          "digitalProductExpirationDate": null,
          "created": null,
          "rewardOrderNumber": null,
          "sentToSourceSystem": null
      },
      {
          "type": null,
          "item": null,
          "productId": "000000000300061887",
          "requestedQuantity": 6,
          "confirmedQuantity": 6,
          "changed": 0,
          "unitPrice": 14.12,
          "materialUom": "EA",
          "sourceOnlineLineId": "6",
          "saleUom": "EA",
          "baseUom": null,
          "alternativeOrderLineNumber": "6",
          "itemCategoryId": null,
          "itemCategoryType": null,
          "conversionMultiplierToBase": null,
          "deliveryMethod": null,
          "digitalAddress": null,
          "deposit": null,
          "depositWithLineItem": null,
          "removedStatus": null,
          "additionalItemStatus": null,
          "replacementProduct": null,
          "orderState": null,
          "orderPrice": 91.5,
          "discounts": [],
          "fulfillment": {
              "fulfilledQuantity": "6",
              "trackingId": null,
              "shippingDate": null,
              "rejectedQuantity": null
          },
          "adjustments": {
              "adjustmentType": null,
              "reasonCode": null,
              "quantity": null
          },
          "taxesInformation": {
              "name": null,
              "type": null,
              "value": null
          },
          "discount": 0,
          "discountIncludingTax": -6.78,
          "taxAmount": 6.78,
          "grandTotal": 91.5,
          "taxDepositAmount": null,
          "securityDeposit": null,
          "sugarLevyTax": null,
          "conversion": null,
          "promotionPoint": null,
          "priceListId": null,
          "idAgreement": null,
          "totalGrossAmount": 84.72,
          "totalDiscountAmount": 0,
          "totalTaxAmount": 6.78,
          "totalNetAmount": 91.5,
          "totalPromotionAmount": 0,
          "promotional": false,
          "promotionId": null,
          "promotionName": null,
          "rewardItemId": null,
          "totalPoints": null,
          "rewardsType": null,
          "rewardStatus": null,
          "expirationDate": null,
          "rewardPrice": null,
          "routeTypeId": null,
          "refunded": null,
          "code": null,
          "codeAdded": null,
          "referenceNo": null,
          "url": null,
          "id": null,
          "expired": null,
          "digitalProductExpirationDate": null,
          "created": null,
          "rewardOrderNumber": null,
          "sentToSourceSystem": null
      }
  ]
}